import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "strike-through" }, [
      _createElementVNode("g", { id: "vector" }, [
        _createElementVNode("path", {
          d: "M4.77378 2.51556C5.46046 1.81896 6.51782 1.33398 8.00191 1.33398C9.55073 1.33398 10.5524 1.86418 11.1871 2.53653C11.8121 3.19867 12.0534 3.96873 12.1462 4.41422L12.2141 4.74056L11.5614 4.87639L11.4935 4.55005C11.4145 4.17052 11.2111 3.53318 10.7023 2.99417C10.2031 2.46536 9.38165 2.00065 8.00191 2.00065C6.67119 2.00065 5.79336 2.43089 5.24856 2.98357C4.69785 3.54224 4.46487 4.24825 4.46487 4.83398C4.46487 5.30687 4.57485 5.6744 4.75622 5.9715C4.93896 6.27085 5.20547 6.51702 5.54462 6.72805C6.22641 7.15227 7.14607 7.40386 8.13387 7.6674H14V8.33407H10.2563C10.2562 8.33406 10.2563 8.33407 10.2563 8.33407H2V7.6674H5.92386C5.66464 7.55755 5.41837 7.43468 5.19242 7.29409C4.78938 7.0433 4.4374 6.72871 4.1872 6.31886C3.93563 5.90676 3.79821 5.41666 3.79821 4.83398C3.79821 4.08349 4.09301 3.20617 4.77378 2.51556Z",
          fill: "currentColor"
        }),
        _createElementVNode("path", {
          d: "M10.1181 9.00076H11.3961C11.6281 9.19408 11.8314 9.41851 11.9925 9.68244C12.2441 10.0945 12.3815 10.5846 12.3815 11.1673C12.3815 12.7046 10.9834 14.6673 8.00191 14.6673C6.4535 14.6673 5.40428 14.138 4.70783 13.4779C4.01923 12.8253 3.69537 12.0643 3.5537 11.6205L3.45233 11.303L4.08742 11.1003L4.18879 11.4178C4.31048 11.799 4.58768 12.4455 5.16643 12.994C5.73733 13.5351 6.62176 14.0007 8.00191 14.0007C10.65 14.0007 11.7149 12.3025 11.7149 11.1673C11.7149 10.6944 11.6049 10.3269 11.4235 10.0298C11.2408 9.73045 10.9743 9.48428 10.6351 9.27325C10.4752 9.17371 10.3021 9.08367 10.1181 9.00076Z",
          fill: "currentColor"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }